import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../public/images/gecam.png';
import { login as loginUser } from '../API/Auth.js';
import { useAuth } from '../App';

function Login() {
  const [email, setEmailInput] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // <- loader
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await loginUser(email, password);
      console.log('Login successful:', response);
      sessionStorage.setItem('token', response.token);
      sessionStorage.setItem('email', response.user.email);
      sessionStorage.setItem("expiry", response.expiresIn);

      login(response.user.email, response.token);
      navigate('/dashboard');
    } catch (error) {
      console.error('Error logging in:', error);
      setError('Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="bg-cover bg-center bg-fixed bg-gray-100"
    >
      <div className="h-screen flex justify-center items-center">
        <div className="bg-white mx-4 p-8 rounded shadow-md w-full md:w-1/2 lg:w-1/3 bg-opacity-70">
        <img src={backgroundImage} width={"40%"} className='mx-auto' alt="Background"/>
          {/* <h1 className="text-2xl font-bold mt-6 mb-4 text-center">Login</h1> */}
          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label
                className="block font-semibold text-gray-700 mb-2"
                htmlFor="email"
              >
                Email 
              </label>
              <input
                className="border border-gray-300 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email"
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmailInput(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label
                className="block font-semibold text-gray-700 mb-2"
                htmlFor="password"
              >
                Mot de passe
              </label>
              <input
                className="border border-gray-300 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {error && (
              <div className="text-red-500 mb-4">
                {error}
              </div>
            )}
              <button
                className="bg-[#F2A549] cursor-pointer hover:bg-[#efb46f] block mx-auto rounded-full hover:bg-opacity-80 mb-4 text-white font-bold py-2 px-4  focus:outline-none focus:shadow-outline"
                type="submit"
                disabled={loading}
              >
                {loading ? 'Loading...' : 'Login'}
              </button>
           
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;


